import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { ApiService } from '../api.service';
import { CourseRegistration } from '../course-registration.model';

@Component({
selector: 'app-course-registrant',
templateUrl: './course-registrant.component.html',
styleUrls: ['./course-registrant.component.scss']
})
export class CourseRegistrantComponent implements OnInit {
    @Input() courseRegistration: CourseRegistration;
    isLoading: boolean = false;
    isLoaded: boolean = false;
    loadingError: string = '';
    loadingMsg: string = '';
    errorMessage: string = '';
    display: boolean = true;
    boards = []
    licenses = []
    pars_person

    constructor(
        private apiService: ApiService,
    ) {}

    ngOnInit() {
        this.get()
    }

    get() {
        if (this.isLoading) return;
        this.isLoading = true;
        this.loadingError = '';

        this.apiService.getRegistrantParsInfo(this.courseRegistration.user).subscribe(
            (data) => {
                this.boards = data.casce_person_board;
                this.licenses = data.casce_person_license;
                this.pars_person = data.casce_pars_person;
                this.isLoaded = true;
                this.isLoading = false;
            },
            (error) => {
                this.isLoaded = true;
                this.isLoading = false;
                this.loadingError = error;
            }
        );
    }

    collapse() {
        if (!this.isLoaded) this.get();
        this.display = !this.display;
    }

    get user() {
        return this.courseRegistration.user;
    }

}
